<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.soru_listesi"  :show_button="false" ></ContentHeader>


<div class="sections mt-4" v-if="$store.state.audit.questionlist">


<div class="grid">
<div class="col-12 md:col-8">
<h3 class="text-primary" v-if="$store.state.audit.display=='sections'">{{$store.state.languages.lang_phrases.bolumler}}</h3>
<h3 class="text-primary" v-if="$store.state.audit.display=='questions'">{{$store.state.languages.lang_phrases.sorular}}</h3>
</div>



<AuditViewSwitch v-show="!is_user_supplier"></AuditViewSwitch>



</div>

  
<template v-if="$store.state.audit.display=='sections'">


<template v-if="$store.state.audit.listview_preparing">
  <FrameOverlay></FrameOverlay>
</template>
<template v-else>
<AuditSectionSelector v-for="item in parentsections" :data="item"></AuditSectionSelector> 
</template>


</template>

<template v-if="$store.state.audit.display=='questions'">



<template v-if="$store.state.audit.listview_preparing">
  <FrameOverlay></FrameOverlay>
</template>
<template v-else>
  <ListviewQuestionlist></ListviewQuestionlist>
</template>






</template>






 <template v-if="inputfields.length">
 <SectionInputfields></SectionInputfields>
 </template>



</div> 

</div>
</template>

<script>

export default {

  name: 'AuditQuestionList',

  data () {
    return {
    	inputfields:[],
    }
  },
  computed:{
  	parentsections()
  	{
  		if(this.$store.state.audit.questionlist.parentsections.length>1)
  		{
  			return this.$store.state.audit.questionlist.parentsections
  		}
  		else
  		{
        
        console.log(this.$store.state.audit)
  			let data = this.getSectionQuestions(this.$store.state.audit.audit.flowsupplier.flow.questionlist.parentsections[0].id)
  			console.log("parents")
  			console.log(data)
  			this.inputfiels = data.section.inputfields
  			return data.child_sections
  		}
  	}
  },
  mounted()
  {
  	this.$store.dispatch('ui/setActiveTab',"sorular") 
    this.$store.dispatch('audit/setDisplay',"sections")
  	this.getData()
  },
  methods:{
  	async getData()
  	{
  		this.getAndParseAuditData()
  	},
  	
  },
}
</script>

<style lang="css" scoped>
</style>